import styled, { keyframes } from 'styled-components';
import {
	PrimaryColor,
	SidelyBlack,
	BackgroundColor,
	PastelPrimaryColor
} from '../../styles/global/css/Utils';

export const SIDEBAR_CLOSE_WIDTH = 40;
const SIDEBAR_OPEN_WIDTH = 280;
const SIDEBAR_PADDING = 8;
const LOGO_CONTAINER_WIDTH = 40;
export const NAV_ITEM_HEIGHT = 40;
const LABEL_PADDING_LEFT = 10;

export const RouteContainer = styled.div<{ isOpen: boolean }>`
	width: ${SIDEBAR_CLOSE_WIDTH}px;
	padding-inline: ${SIDEBAR_PADDING}px;
	transition: width 0.15s;
  height: ${({ isOpen }) => isOpen ? '100%' : 'fit-content'};
	&:hover {
	  width: ${SIDEBAR_OPEN_WIDTH}px;
	  transition-delay: 0.2s;
	}
`;

export const Container = styled.nav<{ isOpen: boolean }>`
    background-color: ${BackgroundColor};
    height: 100vh;
    padding: 0;
    margin: 0;
    box-shadow: ${p => p.isOpen ? `1px 0px 10px color-mix(in oklab, ${SidelyBlack} 15%, transparent)` : `color-mix(in oklab, ${SidelyBlack} 5%, transparent) 1px 0px 2px`};
    z-index: 105;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    display: block;
    overflow-y: scroll;
    overflow-x: hidden;
    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
    /* Hide scrollbar for Chro onSelect={setOperatorme, Safari and Opera */
    position: fixed;
    top: 0px;
    &::-webkit-scrollbar {
      display: none;  /* Safari and Chrome */
    }

`;

export const LogoContainer = styled.div`
    height: ${NAV_ITEM_HEIGHT}px;
    width: ${LOGO_CONTAINER_WIDTH}px;
    min-width: ${LOGO_CONTAINER_WIDTH}px;
    display: flex;
    align-content: center;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    display: inline-block;
    float: left;
`;

const leaveToTop = keyframes`
    from {
      transform: translateY(0);
    }

    to {
      transform: translateY(-500px);
    }
`;

const leaveToRight = keyframes`
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(500px);
    }
`;

const leaveToLeft = keyframes`
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(-500px);
    }
`;

const enterFromTop = keyframes`
    0% { transform: translateY(-500px); }
    60% { transform: translateY(30px); }
    80% { transform: translateY(-10px); }
    100% { transform: translateY(0); }
`;

const enterFromLeft = keyframes`
    0% { transform: translateX(-500px); }
    60% { transform: translateX(30px); }
    80% { transform: translateX(-10px); }
    100% { transform: translateX(0); }
`;

const enterFromRight = keyframes`
    0% { transform: translateX(500px); }
    60% { transform: translateX(-30px); }
    80% { transform: translateX(10px); }
    100% { transform: translateX(0); }
`;

const barrelRoll = keyframes`
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
`;

export const Logo = styled.img<{ animate: number }>`
    width: 30px;
    height: 30px;
    margin: 5px;
    animation: ${p => {
		const rand = Math.floor(Math.random() * 5);
		switch (p.animate % 4) {
			case 1: return `${barrelRoll} 0.5s`;
			case 2:
				switch (rand) {
					case 0: return `${leaveToTop} 0.5s`;
					case 1: return `${leaveToRight} 0.5s`;
					case 2: return 'hinge 2s';
					case 3: return 'bounce-out 1s';
					default: return `${leaveToLeft} 0.5s`;
				}
			case 3:
				switch (rand) {
					case 0: return `${enterFromLeft} 0.5s`;
					case 1: return `${enterFromRight} 0.5s`;
					case 2: return 'bounce-in 1s';
					case 3: return 'flip-enter 1s';
					default: return `${enterFromTop} 0.5s`;
				}
			default: return '';
		}
	}};

  @keyframes hinge {
    0% { transform: rotate(0); transform-origin: top left; animation-timing-function: ease-in-out; }
    20%, 60% { transform: rotate(80deg); transform-origin: top left; animation-timing-function: ease-in-out; }
    40% { transform: rotate(60deg); transform-origin: top left; animation-timing-function: ease-in-out; }
    80% { transform: rotate(60deg); translateY(0); opacity: 1; transform-origin: top left; animation-timing-function: ease-in-out; }
    100% { transform: translateY(calc(100vh - 50px)); opacity: 0; }
  };

  @keyframes bounce-out {
    0% { transform: scale(1); }
    25% { transform: scale(.95); }
    50% {  opacity: 1;  transform: scale(1.1); }
    100% { opacity: 0; transform: scale(.3); }
  };

  @keyframes bounce-in {
    0% { opacity: 0; transform: scale(.3); }
    50% { opacity: 1; transform: scale(1.05); }
    70% { transform: scale(.9); }
    100% { transform: scale(1); }
  };

  @keyframes flip-enter {
	  0% {	transform: perspective(400px) rotateY(0);	animation-timing-function: ease-out;  opacity: 0; }
	  40% {	transform: perspective(400px) translateZ(150px) rotateY(170deg);	animation-timing-function: ease-out; }
	  50% {	transform: perspective(400px) translateZ(150px) rotateY(190deg) scale(1);	animation-timing-function: ease-in; }
	  80% {	transform: perspective(400px) rotateY(360deg) scale(.95);	animation-timing-function: ease-in; }
	  100% {	transform: perspective(400px) scale(1);	animation-timing-function: ease-in;  opacity: 1; }
  }


`;

export const Item = styled.div<{ isActive?: boolean, animate?: boolean }>`
    height: 25px;
    width: 25px;
    display: block;
    background-color: ${p => p.isActive ? PastelPrimaryColor : BackgroundColor};
    cursor: ${p => p.animate ? 'none' : ''};
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const DotContainer = styled.div`
  width: ${LOGO_CONTAINER_WIDTH}px;
  box-sizing: border-box;
  padding-left: 10px;
  flex-shrink: 0;
`;

export const TextItem = styled.p<{ isActive?: boolean, isOpen?: boolean, weight?: boolean }>`
    width: calc(100% - ${LOGO_CONTAINER_WIDTH}px);
    height: ${NAV_ITEM_HEIGHT}px;
    box-sizing: border-box;
    margin: 0;
    color: ${p => p.isActive ? PrimaryColor : ''};
    display: ${p => p.isOpen ? 'inline-flex' : 'none'};
    align-items: center;
    vertical-align: top;
    font-size: 12px;
    padding: 0 10px 0 ${LABEL_PADDING_LEFT}px;
    border-radius: 5px;
    font-weight: ${p => p.weight ? 500 : ''};
    background-color: ${BackgroundColor};
`;

export const SubText = styled.p<{ isActive?: boolean, isOpen?: boolean, weight?: boolean, textAlign?: string }>`
  color: ${p => p.isActive ? PrimaryColor : ''};
  display: ${p => p.isOpen ? 'block' : 'none'};
  font-size: 12px;
  font-weight: ${p => p.weight ? 500 : ''};
  text-align: ${p => p.textAlign ?? 'center'};
  padding: 0 0 0 ${LABEL_PADDING_LEFT}px;
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const NavContainer = styled.a<{ isOpen: boolean }>`
  height: ${NAV_ITEM_HEIGHT}px;
  display: inline-block;
  width: ${p => !p.isOpen ? '100%' : '85%'};
  overflow: hidden;
  min-width: ${SIDEBAR_CLOSE_WIDTH}px;
  cursor: pointer;
`;

export const SidebarItemContainer = styled.div<{ index: number }>`
  height: ${NAV_ITEM_HEIGHT}px;
  width: 100%;
  display: flex;
  align-items: center;
  &[hidden] { display: none; }
  animation-duration: 10s;
  animation-iteration-count: infinite;
  animation-delay: ${p => p.index}s;

  @keyframes flip-enter-2 {
	  0% {	transform: perspective(400px) rotateY(0);	animation-timing-function: ease-out;  opacity: 1; }
	  5% {	transform: perspective(400px) translateZ(150px) rotateY(170deg);	animation-timing-function: ease-out; }
	  6% {	transform: perspective(400px) translateZ(150px) rotateY(190deg) scale(1);	animation-timing-function: ease-in; }
	  10% {	transform: perspective(400px) rotateY(360deg) scale(.95);	animation-timing-function: ease-in; }
	  12% {	transform: perspective(400px) scale(1);	animation-timing-function: ease-in;  opacity: 1; }
	  100% {	transform: perspective(400px) rotateY(0);	animation-timing-function: ease-out;  opacity: 1; }
  }
`;
